import React from 'react';
import { Container } from 'flux/utils';

import drinksStore from '../stores/drinks';

import Drinks from './drinks';
import DrinksEmpty from './drinks-empty';


class DrinksList extends React.Component {
  static getStores() {
    return [drinksStore];
  }

  static calculateState() {
    return {
      drinks: drinksStore.getState(),
    };
  }

  constructor() {
    super();
    this.state = {
      ready: false,
    };
  }

  render() {
    const { drinks } = this.state;
    return (
      <div className="view drinkslist">
      {drinks && drinks.drinks.length ?
       <Drinks {...drinks} />
        : <DrinksEmpty showCalcView={this.sidebarRight} />
      }
      </div>
    )
  }
}

export default Container.create(DrinksList);



// WEBPACK FOOTER //
// ./src/components/drinks-list.js